export const homePath = '/';
export const homeAliasPath = '/confluence-sandbox-editor';

export const matchHomePath = (pathname: string) => {
  // Preserve the old exact, case-insensitive routes and optional trailing slash.
  if (pathname === homePath || pathname === '//') {
    return homePath;
  }
  if (/^\/confluence-sandbox-editor\/?$/i.test(pathname)) {
    return homeAliasPath;
  }
  return null;
};
